import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Header from './../../Layout/Header1';
import Footer from './../../Layout/Footer1';
import PageTitle from './../../Layout/PageTitle';
import SectionCounter from './../../Element/SectionCounter';
import TestimonialCarousel from './../../Element/TestimonialCarousel';
import FormStyle from './../../Element/FormStyle';

//Images
import bnr1 from './../../../images/banner/bnr4.jpg';
import bgmap from './../../../images/background/bg-map.jpg';
import bg1 from './../../../images/background/bg1.jpg';
import about from './../../../images/about/pic3.jpg';

const iconWraper=[
	{icon: <i className="flaticon-email" />, title:'Email for Transactions'},
	{icon: <i className="flaticon-start" />, title:'Email for Promotions'},
	{icon: <i className="flaticon-checked" />, title:'OTP Email Services'},
	{icon: <i className="flaticon-computer" />, title:'API\'s Email Services'},
	{icon: <i className="flaticon-rocket-ship" />, title:'Email Campaigns'},
	{icon: <i className="flaticon-box" />, title:'Email Id\'s Filteration'},
];

const titleBlog=[
	{title1:'No Upfront Contracts', title2: 'or Hidden Fees', para: 'No monthly subscription fees, pay as you use. Price does not increase alongside the size of your database - send bulk email how you want and only pay for what you use.'}, 
	{title1:'Maximum', title2: 'Deliverability!', para: 'We pride ourselves on maintaining the sender reputation of our IP addresses. Choose whiteBing to ensure that you get the most out of your contact list.'}, 
	{title1:'100% Uptime', title2: 'SLA Guarantee', para: 'We’re so confident in our reliability, we offer a 100% uptime SLA guarantee so you can be sure your message reaches when you need it to.'}, 
	{title1:'Email', title2: 'Scheduling', para: 'Our bulk email service also gives you the option of scheduling emails to be sent automatically. Simply choose a date and time, and save yourself the task of having to manually send email blasts at odd times.'}, 
	{title1:'Full Integration', title2: 'Support', para: 'We play nice with others; integrate your current business systems with the whiteBing email API to send bulk email seamlessly. There’s always a human on the other end, ready to help.'}, 
	{title1:'Relax, Help Is', title2: 'Always At Hand', para: 'Our global 24/7 chat is industry leading and we\'re proud to employ real humans in support to help our real humans in use. We understand businesses can require quick, efficient support at any time of the day or night.'}, 
];

class EmailSolutions extends Component {


    render() {
        return (
            <>
                <Header />

                <div className="page-content bg-white">
                    {/* <!-- inner page banner --> */}
                    <div className="dlab-bnr-inr overlay-primary" style={{ backgroundImage: "url(" + bnr1 + ")" }}>
                        <PageTitle motherMenu='Email Solutions' activeMenu='Email Solutions' />
                    </div>
                    {/* <!-- inner page banner END --> */}
                    <div className="content-block">
                        {/* <!-- About Us --> */}
                        <div className="section-full content-inner exp-services">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="section-head text-black text-center">
                                            <h4 className="text-gray-dark font-weight-500 m-b10">Email Solutions</h4>
                                            <h2 className="box-title m-tb0">Scalable, Powerful & affordable Mass Email Solutions on your way.<span className="bg-primary"></span></h2>
                                            <p className="font-weight-300 font-18">Get started quickly by sending <strong className="text-primary">eMail</strong> via our web portal or integrate eMail API into your everyday activities via our world-class <strong className="text-yellow">API's,</strong> Email is <strong className="text-red">Low-Cost</strong> and <strong className="text-pink">Affordable</strong> and timely engagement with your customers, target your customers in <strong className="text-blue">real-time</strong> to achieve valuable business outcomes.</p>
                                        </div>
                                        <div className="row serv">
											{iconWraper.map((data,index)=>(	
												<div className="col-lg-2 col-md-4 col-sm-6 m-b30" key={index}>
													<div className="icon-bx-wraper expertise  bx-style-1 p-lr10 p-tb20 center">
														<div className="icon-bx-sm bg-primary radius m-b20">
															<Link to={"#"} className="icon-cell">{data.icon}</Link>
														</div>
														<div className="icon-content">
															<h5 className="dlab-tilte"><Link to={"#"}>{data.title}</Link></h5>
														</div>
													</div>
												</div>
											))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- Our Services --> */}
                        {/* <!-- About Us --> */}
                        <div className="section-full">
                            <div className="container-fluid">
                                <div className="row dzseth">
                                    <div className="col-lg-6 col-md-12 p-a0 img-fix">
                                        <img src={about} alt="" className="img-cover" />
                                    </div>
                                    <div className="col-lg-6 col-md-12 bg-black-light p-lr0 dis-tbl">
                                        <div className="p-a30 dis-tbl-cell ">
                                            <div className="max-w500 m-auto p-tb30">
                                                <div className="row">
                                                    <div className="col-lg-12 text-white">
                                                        <h3 className="box-title m-b10">Send, Receive & Track <br/>Bulk Email Messages Worldwide<span className="bg-primary"></span></h3>
                                                        <h5 className="m-b30">We make it easy, fast and affordable. With bulk email service, you can send marketing emails to your mass list without the headache.</h5>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-12 m-b30 chosesus-content">
                                                        <ul className="list-checked primary text-white">
                                                            <li><span>Easy Integration, Scalable and Reliable.</span></li>
                                                            <li><span>The Trusted Leader in Email Marketing.</span></li>
                                                            <li><span>No Upfront Contracts or Fees. Uptime SLA Guarantee 100%.</span></li>
                                                        </ul>
                                                        <p>We’re so confident in our reliability, we offer a 100% uptime SLA guarantee so you can be sure your message reaches when you need it to.</p>
                                                        <p className="list-checked primary text-white">Talk to us through live chat, phone, contact form or email. There’s always a human on the other end, ready to help.</p>
                                                        <Link to={"#"} className="site-button radius-xl outline white">Read More <i className="fa fa-long-arrow-right"></i></Link>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- About Us End --> */}
                        {/* <!-- About Us --> */}
                        <div className="section-full content-inner">
                            <div className="container">
                                <div className="section-head text-black text-center">                                
                                    <h2 className="box-title m-tb0">Why Choose <strong className="text-blue">whiteBing </strong>for Your Mass Mailing Partner<span className="bg-primary"></span></h2>
                                    <p>We take privacy and reputation very seriously. Bulk emailing is a valid means to promote your business, when it is done in a respectful manner. We have a dedicated team making sure that users adhere strictly to our best practices guidelines, safeguarding your online reputation.</p>
                                </div>
                            </div>
                            <div className="container">
                                <div className="row ">
									{titleBlog.map((data,index)=>(
										<div className="col-lg-4 col-md-6 col-sm-6 m-b30" key={index}>
											<div className="icon-bx-wraper expertise  bx-style-1 p-a30 center">
												<div className="icon-content">
													<h4 className="dlab-tilte text-uppercase"><Link to={"#"}>{data.title1}	<br/>{data.title2}</Link></h4>
													<p>{data.para}</p>
													<Link to={"#"} className="site-button radius-xl outline outline-2">Read Move</Link>
												</div>
											</div>
										</div>
									))}                                    
                                </div>
                            </div>
                        </div>
                        {/* <!-- Our Services --> */}
						{/* <!-- Why Chose Us --> */}
							<SectionCounter />
                        {/* <!-- Why Chose Us End --> */}
                        {/* <!-- Testimonials --> */}
                        <div className="section-full content-inner"   style={{ backgroundImage: "url(" + bgmap + ")", backgroundPosition: "center", backgroundRepeat: "no-repeat" }}>
                            <div className="container">
                                <div className="section-head text-center">
                                    <h2 className="box-title m-tb0">Our Testimonials<span className="bg-primary"></span></h2>
                                    <p> Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the </p>
                                </div>
                                <div className="section-content m-b30 ">
									<TestimonialCarousel /> 
                                </div>
                            </div>
                        </div>
                        {/* <!-- Testimonials END --> */}
                        {/* <!-- Get in touch --> */}
                        <div className="section-full overlay-primary-dark bg-img-fix" style={{ backgroundImage: "url(" + bg1 + ")" }}>
                            <FormStyle />
                        </div>
                        {/* <!-- Get in touch --> */}
                    </div>
                    {/* <!-- contact area END --> */}
                </div>

                <Footer />
            </>
        )
    }
}
export default EmailSolutions;